<i18n>
{
  "en": {
    "table": {
      "headers": {
        "email": "Email",
        "name": "Name",
        "roleid": "Permissions",
        "country": "Country",
        "company": "Company",
        "created": "Created",
        "actions": "Actions",
        "mintime": "Min time (days)",
        "maxtime": "Max time (days)",
        "maxcredits": "Max credits",
        "referenceusername": "Reference user"
      }
    },
    "form": {
      "title": {
        "add": "Add user",
        "edit": "Edit user",
        "delete": "Delete user?"
      },
      "fields": {
        "email": "EMail",
        "firstname": "First name",
        "middlename": "Middle name",
        "lastname": "Last name",
        "country": "Country",
        "company": "Company",
        "permissions": "User permissions",
        "password": "Password",
        "repeatPassword": "Repeat password", 
        "referenceuser": "Reference user",
        "maxcredit": "Credit maximum",
        "mintime": "Time minimum",
        "maxtime": "Time maximum"
      },
      "options": {
        "permissions": {
          "select": "Please select a role",
          "ellipseadmin": "Ellipse Administrator",
          "ellipsetech": "Ellipse Technician",
          "creditdistributor": "Credit Distributor"
        }
      },
      "descriptions": {
        "optional": "(Optional)",
        "referenceuser": "Remote Assistance reference user",
        "days": "(Days)"
      },
      "texts": {
        "delete": "This will delete the user {email}. This action cannot be undone!"
      }
    },
    "buttons": {
      "save": "Save",
      "update": "Update",
      "add": "Add",
      "edit": "Edit",
      "delete": "Delete",
      "columns": "Columns",
      "export": "Export"
    }
  },
  "da": {
    "table": {
      "headers": {
        "email": "Email",
        "name": "Navn",
        "roleid": "Rettigheder",
        "country": "Land",
        "company": "Firma",
        "created": "Oprettet",
        "actions": "Handlinger",
        "mintime": "Min tid (dage)",
        "maxtime": "Max tid (dage)",
        "maxcredits": "Max kredit",
        "referenceusername": "Reference bruger"
      }
    },
    "form": {
      "title": {
        "add": "Tilføj bruger",
        "edit": "Rediger bruger",
        "delete": "Slet bruger?"
      },
      "fields": {
        "email": "Email",
        "firstname": "Fornavn",
        "middlename": "Mellemnavn",
        "lastname": "Efternavn",
        "country": "Land",
        "company": "Firma",
        "permissions": "Rettigheder", 
        "password": "Password",
        "repeatPassword": "Gentag password",
        "referenceuser": "Reference bruger",
        "maxcredit": "Credit maximum",
        "mintime": "Tids Minimum",
        "maxtime": "Tids maximum"
      },
      "options": {
        "permissions": {
          "select": "Vælg venligst en rolle",
          "ellipseadmin": "Ellipse Administrator",
          "ellipsetech": "Ellipse Teknikker",
          "creditdistributor": "Kredit Distributør"
        }
      },
      "descriptions": {
        "optional": "(Valgfri)",
        "referenceuser": "Remote Assistance reference bruger",
        "days": "(Dage)"
      },
      "texts": {
        "delete": "Dette vil slette brugeren {email}. Denne handling kan ikke fortrydes!"
      }
    },
    "buttons": {
      "save": "Gem",
      "update": "Opdater",
      "add": "Tilføj",
      "edit": "Rediger",
      "delete": "Slet",
      "columns": "Kolonner",
      "export": "Eksporter"
    }
  }
}
</i18n>

<template>
  <layout v-on:onUserUpdate="onUserUpdate">
    <b-container fluid>
      <b-row>
        <b-col> 
          <b-row class="my-2 ml-1 mr-1"  align-h="between">
            <b-button variant="success" v-on:click="showAddUser">
              {{$t('buttons.add')}}
            </b-button>

            <div class="mr-1">
              <b-row>
              <b-form inline class="mr-2">
                <b-input block="false" placeholder="filter" v-model="filter"></b-input>
              </b-form>

              <b-btn variant="secondary" class="mr-2" href="/api/v1/users/export">
                {{$t('buttons.export')}}
              </b-btn>

              <b-dropdown right :text="$t('buttons.columns')" variant="secondary"  >
             
                <b-dropdown-item-button v-on:click="togggleColumn('Email')"> 
                  <span v-bind:class="{ shown: config['Email'].visible }">
                    {{ $t('table.headers.email') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('FullName')">
                  <span v-bind:class="{ shown: config['FullName'].visible }">
                  {{ $t('table.headers.name') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('Country')">
                  <span v-bind:class="{ shown: config['Country'].visible }">
                  {{ $t('table.headers.country') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('CompanyName')">
                  <span v-bind:class="{ shown: config['CompanyName'].visible }">
                  {{ $t('table.headers.company') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('RoleID')">
                  <span v-bind:class="{ shown: config['RoleID'].visible }">
                  {{ $t('table.headers.roleid') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('Created')">
                  <span v-bind:class="{ shown: config['Created'].visible }">
                  {{ $t('table.headers.created') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('Limits.MaxCredits')">
                  <span v-bind:class="{ shown: config['Limits.MaxCredits'].visible }">
                  {{ $t('table.headers.maxcredits') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('Limits.MinTime')">
                  <span v-bind:class="{ shown: config['Limits.MinTime'].visible }">
                  {{ $t('table.headers.mintime') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('Limits.MaxTime')">
                  <span v-bind:class="{ shown: config['Limits.MaxTime'].visible }">
                  {{ $t('table.headers.maxtime') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('ReferenceUser.ReferenceUsername')">
                  <span v-bind:class="{ shown: config['ReferenceUser.ReferenceUsername'].visible }">
                  {{ $t('table.headers.referenceusername') }}
                  </span>
                </b-dropdown-item-button>

                <b-dropdown-item-button v-on:click="togggleColumn('Actions')">
                  <span v-bind:class="{ shown: config['Actions'].visible }">
                  {{ $t('table.headers.actions') }}
                  </span>
                </b-dropdown-item-button>
              
              </b-dropdown>
              </b-row>
            </div> 

          </b-row>
          
          <b-table striped hover :items="users" small :fields="tableConfiguration" responsive="xl" :filter="filter"     :sort-compare="sortCompareAdvanced" >

            <template v-slot:head(Email)="scope">
              {{$t('table.headers.email')}}
            </template>

            <template v-slot:head(FullName)="scope">
              {{$t('table.headers.name')}}
            </template>
   
            <template v-slot:head(Country)="scope">
              {{$t('table.headers.country')}}
            </template>

            <template v-slot:head(CompanyName)="scope">
              {{$t('table.headers.company')}}
            </template>

            <template v-slot:head(RoleID)="scope">
              {{$t('table.headers.roleid')}}
            </template>

            <template v-slot:head(Created)="scope">
              {{$t('table.headers.created')}}
            </template>

            <template v-slot:head(Limits.MinTime)="scope">
              {{$t('table.headers.mintime')}}
            </template>

            <template v-slot:head(Limits.MaxTime)="scope">
              {{$t('table.headers.maxtime')}}
            </template>
     
            <template v-slot:head(Limits.MaxCredits)="scope">
              {{$t('table.headers.maxcredits')}}
            </template>
     
            <template v-slot:head(ReferenceUser.ReferenceUsername)="scope">
              {{$t('table.headers.referenceusername')}}
            </template>
              
            <template v-slot:head(Action)="scope">
              {{$t('table.headers.actions')}}
            </template>

            <template v-slot:cell(RoleID)="data">
              <span v-if="data.item.RoleID === 0"> {{$t('form.options.permissions.ellipseadmin')}} </span>
              <span v-if="data.item.RoleID === 10">{{$t('form.options.permissions.ellipsetech')}}</span>
              <span v-if="data.item.RoleID === 20">{{$t('form.options.permissions.creditdistributor')}}</span>
            </template>

            <template v-slot:cell(FullName)="data">
              {{data.item.FirstName}} {{data.item.MiddleName}} {{data.item.LastName}}
            </template>

            <template v-slot:cell(Actions)="data">
              <b-button size="sm"  variant="dark" @click="showEditUser(data)">
                {{$t('buttons.edit')}}
              </b-button>
              <b-button size="sm"  variant="danger" @click="verifyDeleteUser(data)">
                {{$t('buttons.delete')}}
              </b-button>
            </template>

            <template v-slot:cell(Created)="data">
              {{ parseDate (data.item.Created) }}
            </template>

          </b-table>


        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="deleteUserConfirm" hide-footer :title="$t('form.title.delete')">
      <div class="d-block text-center">
        <h6>{{ $t('form.texts.delete', { email: this.user.Email }) }}</h6>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="deleteUser(user)">{{$t('buttons.delete')}}</b-button>
    </b-modal>

    <user-modal :modal-action="modalAction" :visible.sync="showUserDialog" :user.sync="user" v-on:success="onSuccess"></user-modal>

  </layout>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

import Layout from './Layout'
import UserModal from './UserModal'

import roles from '../utils/roles.js'
import errorParser from '../utils/errorParser.js'
import elg from '../api/elg.gateway.js'

export default {
  components: {
    Layout,
    UserModal
  },
  data() {
    return {
      config: {
        'Email': {
          sortable: true,
          visible: true
        },
        'FullName': {
          label: 'Name',
          sortable: true,
          visible: true
        },
        'Country': {
          sortable: true,
          visible: false
        },
        'CompanyName': {
          sortable: true,
          visible: true
        },
        'RoleID': {
          sortable: true,
          visible: true
        },
        'Created': {
          sortable: true,
          visible: false
        },
        'Limits.MaxCredits': {
          sortable: true,
          visible: true
        },
        'Limits.MinTime': {
          sortable: true,
          visible: true
        },
        'Limits.MaxTime': {
          sortable: true,
          visible: true
        },
        'ReferenceUser.ReferenceUsername': {
          sortable: true,
          visible: false
        },
        'Actions': {
          class: 'table-buttons-column',
          visible: true
        },
      },
      filter: null,
      users: [],
      user: {
        Role: undefined,
        ReferenceUser: {
          ReferenceUsername: '',
        },
        Limits: { }
      },
      modalAction: undefined,
      showUserDialog: false
    };
  },

  computed: {
    passwordRequired() {
      return this.modalAction === 'add';
    },
    tableConfiguration() {
      return _.values(_.mapValues(this.config, function(value, key, object){
        if(value.visible){
          value.key = key;
          return value;
        }
      }))
    }
  },

  methods: {
    parseDate (date){
      return moment(date).format('L')
    },
    reset(){
      this.$set(this, 'user', {
        Role: undefined,
        ReferenceUser: {
          ReferenceUsername: ''
        },
        Limits: { }
      });
    },
    onUserUpdate(user){
      this.modalAction = 'edit'
      var index = _.findIndex(this.users, function(u){
        return u.UserID === user.UserID;
      })
      this.$set(this.users, index, user);
    },
    onSuccess(user){
      if(this.modalAction === 'edit'){
          this.$set(this.users, this.user.index, this.user);
      }else{
        this.users.push(user);
      }
    },
    showAddUser(){
      this.errors.clear(); 
      this.reset();
      this.showUserDialog = true;
      
      this.modalAction = 'add'; 
      this.showUserDialog = true;
    },
    showEditUser(data){
      //this.user = data.item;
      this.user = _.clone(data.item);
      this.user.index = data.index;
      this.user.Role = roles(this.user.RoleID);

      this.modalAction = 'edit';
      this.showUserDialog = true;
    },
    verifyDeleteUser(data){
      this.user = data.item;
      this.user.index = data.index;
      this.$refs.deleteUserConfirm.show();
    },
    deleteUser(user){
      elg()
      .delete(`/api/v1/users/${user.UserID}`)
      .then( res => {
        this.$delete(this.users, user.index);
        this.$refs.deleteUserConfirm.hide();
      })
      .catch( err => {
        console.error('Error: %j', err);
      })
      .finally( () => {
        this.reset();
      });

    },
    togggleColumn(column){
      this.$set(this.config[column], 'visible', !this.config[column].visible)
    },

    exportUsers(){

    },
    /* Sorting Methods */
    flatten: function (obj) {
      var root = {};
      (function tree(obj, index) {
        var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) continue;
          root[index + key + suffix] = obj[key];
          if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
          if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
        }
      })(obj, "");
      return root;
    },
    sortCompareAdvanced: function (a, b, key) {
      if( key === 'FullName' ){
        var _a = a['FirstName'] + a['MiddleName'] + a['LastName'];
        var _b = b['FirstName'] + b['MiddleName'] + b['LastName'];
        return _a.localeCompare(_b, undefined, {
          numeric: true
        });
      }

      if (this.flatten(a)[key] === undefined && this.flatten(b)[key] === undefined ){
        return 0;
      }
      else if( this.flatten(a)[key] === undefined && this.flatten(b)[key] !== undefined ){
        return 1;
      }
      else if(this.flatten(a)[key] !== undefined && this.flatten(b)[key] === undefined ){
        return -1;
      }
      else if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else {
        // Stringify the field data and use String.localeCompare
        return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
          numeric: true
        })
      }
    },
  },

  mounted() {
    elg()
    .get('/api/v1/users')
    .then( res => {
      for( var i = 0; i < res.data.length; i++ ){
        res.data[i].MaxCredits = res.data[i].Limits.MaxCredits;
        this.users.push(res.data[i]);
      }
    });
  }

};
</script>

<style scoped>
  .button-column{
    width:     150px;
    min-width: 150px;
  }

  .shown {
    font-weight: bold !important;
  }

  .dropdown-item .shown{
    font-weight: bold !important;
  }

  .error{
    color: red;
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// WebApp/components/Users.vue